<!-- src/views/purchase/_modules/purchase-rent-plan/DestinationSelect.vue -->
<script setup>

import Dropdown from '@/components/ui/Dropdown.vue';
import { onMounted, ref, watch } from 'vue';
import { useDestinationStore } from '../../../../store/destinationStore';

const emit = defineEmits(['selectDestination']);
const model = defineModel()

const destinationStore = useDestinationStore();
const loading = ref(false);

async function searchDestination(query) {
    loading.value = true;
    await destinationStore.fetchDestinations({
        query: query,
        limit: 10,
    });
    loading.value = false;
}

function selectDestination(destinationId) {
    const destination = destinationStore.findDestinationById({"destination_id": destinationId});
    emit('selectDestination', destination);
};

onMounted(async () => {
    await searchDestination();
});

</script>

<template>
    <Dropdown
        v-model="model"
        :items="destinationStore.getDestinationsForDropdown"
        :placeholder="$t('purchase-rent-page.plans.destination_dropdown_placeholder')"
        :searchable="true"
        :loading="loading"
        @search="searchDestination"
        @select="selectDestination"
    />
</template>

